"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[119],{

/***/ 9119:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2903);

var viewBox = "0 0 679.3 144";
var height = "14px";
var Budget = function Budget() {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsxs */ .BX)("svg", {
        role: "img",
        "aria-label": "Budget",
        viewBox: viewBox,
        height: height,
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("path", {
                fill: "#F78B00",
                d: "M87.1 105.7h70.2V1.7z"
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("path", {
                fill: "#ED5505",
                d: "M0 0v105.7L157.3 0z"
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("path", {
                fill: "#00285F",
                d: "M668.1 4c6.2 0 11.2 5 11.2 11.2s-5 11-11.2 11c-6.2 0-11.2-4.8-11.2-11S662 4 668.1 4zm0 20.6c5.2 0 9.5-4.2 9.5-9.4a9.4 9.4 0 1 0-9.5 9.4zm-4.3-15.8h4.4c2.3 0 4.7 1 4.7 3.7 0 1.9-1.2 3-3 3.4l3.4 5.5h-2.7l-3-5.2H666v5.2h-2.2V9zm4 5.6c1.3 0 2.8-.4 2.8-2 0-1.3-1.3-1.6-2.5-1.6h-2v3.6h1.7zm-27 76c-8.9 0-13-4.3-13-13.5V41.4h17V26h-17V4h-17.3V77c0 18.4 10.5 29.4 27.5 29.4 3.6 0 7-.5 7-.5V90.2c-2 .2-3.3.2-4.2.2zm-50-55a37.1 37.1 0 0 0-27.3-11.1c-22 0-39 18.2-39 41.1 0 23.2 16.6 41 39.4 41 12 0 24-6.3 31.5-15.8l-13.6-9.5c-4.4 6.1-12 9.4-18 9.4-9.2 0-18.7-6.7-21-18H601s5.4-20.8-10.2-37.1zM543 58c.6-4.8 6.3-17.9 20.5-17.9 13.7 0 19.8 12.7 20.3 17.9H543zm-44.6-32v7.2c-6.2-5.9-14.5-9-23-9a39.8 39.8 0 0 0-39.6 41 39.8 39.8 0 0 0 39.6 41.1c8.1 0 16.3-3 22.6-8.6 0 0 3.5 30-23 30-11.1 0-19-8-22.6-14l-13.8 9.7A41.2 41.2 0 0 0 475 144c10.2 0 20.3-2.9 27.4-9.2 8.4-7.4 13-17.7 13-31.6V26h-17zm-23 64.3c-12.5 0-22.2-11.1-22.2-25.2 0-13.7 10-24.9 22.2-24.9 12.3 0 22.6 11.4 22.6 24.9 0 13.8-10.1 25.2-22.6 25.2zm-89.1 16a39.8 39.8 0 0 1-39.7-41 39.9 39.9 0 0 1 39.7-41c8 0 16.2 2.9 22.5 8.5V0H426v104.7h-16.9v-7.3c-6.2 5.9-14.5 9-23 9zm0-66c-12.5 0-22.3 11-22.3 25.2 0 13.7 10 24.8 22.3 24.8 12.2 0 22.5-11.3 22.5-24.8 0-13.9-10.1-25.1-22.5-25.1zM338 66.7V26h-17.4v40.6c0 14.5-7.4 23.8-19 23.8-11.5 0-18.9-9.4-18.9-23.8V26h-17.4v40.6c0 24.2 16.2 39.7 36.4 39.7S338 90.8 338 66.6zm-154.2 39.1V0h36.7C234.8 0 252 7.5 252 27.4c0 11.9-5.5 19.5-10.5 22.3 13.4 5.2 16 18 16 25.5 0 17-13.9 30.5-36 30.5h-37.7zM219.4 90c4.6 0 8.1-.5 11-1.7 5.6-2.5 9-7.2 9.1-14 0-6.5-3.6-11.4-9.2-13.8a29 29 0 0 0-12.3-1.8h-16.5v31.3h18zm-2.9-46.5c3.2 0 8.4-.1 11.4-1.6 4.6-2.5 6-6.4 6-12.4 0-6.5-3.8-10.3-7-11.8a23.5 23.5 0 0 0-10.8-1.8h-14.6v27.6h15z"
            })
        ]
    });
};
// eslint-disable-next-line import/no-default-export
/* harmony default export */ __webpack_exports__["default"] = (Budget);


/***/ })

}]);